import { useMutation } from '@tanstack/react-query';

type JobPostImportTextRequest = {
  text: string;
};

export default function usePostJobPostImportText() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ text }: JobPostImportTextRequest) => {
      const response = await fetch('/agent/api/job_post_import_requests', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ text }),
      });

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ errors: ['テキストの送信に失敗しました'] }));
        throw new Error(errorData.errors?.[0] || 'テキストの送信に失敗しました');
      }

      return await response.json();
    },
  });
}
